//RUTAS PRODUCTOS
//--gam
export const urlGetProducts = "/api/products";
export const urlCreateProducts = "/api/products";
export const urlEditProducts = "/api/products";
export const urlGetTiposProducts = "/api/products/tipos";
export const urlCreateTiposProducts = "/api/products/tipos";
export const urlEditTiposProducts = "/api/products/tipos";
